import React, { useEffect, useState } from 'react';
import { Drawer, Form, TextArea, Input, Select,Radio, DatePicker, Button, format, useDispatch, useSelector } from '../../AntComponent';
import { saveProject } from '../../../store/actions/project-management/ProjectAction';
import { getProjectType,getProjectManagerList } from '../../../store/actions/project-management/ProjectSettingAction';
import moment from 'moment';

export default function AddProject(props) {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [openDrawer, setOpenDrawer] = useState(props.data.openDrawer);
    const { typeList,projMngList } = useSelector(state => state.projectSetting);
    const { profileInfo } = useSelector(state => state.userPrf);
    const { prjListData, prjInfo, success2, success8 } = useSelector(state => state.project);
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const yearID = profileInfo?.data?.year[0]?.yearID;
    const appUserID = profileInfo?.data?.appUser?.appuserID;
    const locationID = profileInfo?.data?.location[0]?.locationID;
    const productID = profileInfo?.data?.tenantDetail?.kProductID;
    const formValue = props.data.rowData !== null ? props.data.rowData[0] : null;
    const datas = props.data.formVal;
    const projecNo = formValue?.projectNo || "";
    const [specificValue,setSpecificValue] = useState();
    const prjTypeOptions = typeList?.data?.map((item) => {
        return {
            label: item.initiativeType,
            value: item.initiativeTypeID
        }
    });
    const prjManagerList = projMngList?.data?.map((item) =>{
        return{
            label:item.fullName,
            value:item.empID, 
        }
    })

    function getProjectTypeList() {
        if (tenantID) {
            let ids = `${tenantID}/${locationID}/0`;
            dispatch(getProjectType(ids));
        }
    }
    
    function getProjectmanagerList() {
        let inputJson ={
            "ProductID": productID,
            "TenantID": tenantID,
            "IsManager": true
        }
        dispatch(getProjectManagerList(inputJson))
    }
    useEffect(() => {
        getProjectTypeList();
        getProjectmanagerList();
    }, [dispatch, tenantID]);

    const priorityOptions = [
        {
            label: "High",
            value: "High"
        },
        {
            label: "Medium",
            value: "Medium"
        },
        {
            label: "Low",
            value: "Low"
        }
    ];

    const billableTypeOptions = [
        {
            label: "Fixed budget",
            value: "Fixed budget",
        },
        {
            label: "Time & Material",
            value: "Time & Material"
        },
        {
            label: "Non-billable",
            value: "Non-billable"
        }
    ];

    const completionOptions = [
        {
            label:"Milestone based",
            value:"MileStone Based"
        },
        {
            label:"Project duration based",
            value:"Project duration based"
        }
    ]


    const onSubmitForm = (values) => {
        let inputJson = {
            "ProjectID": props.data.projectID,
            "ProjectNo": projecNo,
            "ProjectName": values.projectName,
            "ProjShortName": values.projectShortName,
            "InitiativeTypeID": values.projectType,
            "IsBillable": true,
            "BillableName": values.billableType,
            "EstStartDate": format(new Date(values.estStartDate), "yyyy-MM-dd"),
            "EstEndDate": format(new Date(values.estEndDate), "yyyy-MM-dd"),
            "YearID": yearID,
            "ManagerID": values.manager.toString(),
            "Priority": values.priority,
            "Description": values.description,
            "ProjStatus": "Active",
            "CompletionMode": values.projIndBy,
            "Sponsor": values.sponsorName,
            "ExecutiveSponsor": "",
            "TenantID": tenantID,
            "LocationID": locationID,
            "CreatedBy": appUserID
        }
        dispatch(saveProject(inputJson));
        hanldeCloseDrawer();
        form.resetFields();
        props.data.addCallbackFunc(false, true);
    }

    const loadData = () => {
        form.setFieldsValue({
            projectName: formValue?.projectName || "",
            projectShortName: formValue?.projShortName || "",
            projectType: formValue?.initiativeTypeID || "",
            priority: formValue?.priority || "",
            billableType: "Fixed budget",
            sponsorName: formValue?.sponsor || "",
            projIndBy: formValue?.projIndBy || "",
            estStartDate: datas ? moment(datas?.estStartDate) : null,
            estEndDate: datas ? moment(datas.estEndDate) : null,
            manager : formValue?.manager || "",
            description: formValue?.description
        });
        setSpecificValue(moment(datas?.estStartDate));
    }
    useEffect(() => {
        loadData();
    }, []);
    const hanldeCloseDrawer = () => {
        setOpenDrawer(false);
        props.data.addCallbackFunc(false, false);
    }
    const disabledDate = (current) => {
        // Disable dates after today
        return current && current < moment().startOf('day');
    };
    const disableEstEndDate=(current)=>{
        return current && (current < specificValue)
    }

    const handleDateChange=(value)=>{
        setSpecificValue(value);
    }

    return (

        <Drawer  title="Add Project" width={550} placement="right" onClose={hanldeCloseDrawer} open={openDrawer}>
            <Form
                form={form}
                onFinish={onSubmitForm}
                layout="vertical">
                <div className='row m-0'>
                    <Form.Item label="Project Name/Title" name="projectName" className='col right-col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <TextArea />
                    </Form.Item>
                </div>
                <div className='row m-0'>
                    <Form.Item label="Project Short Name" name="projectShortName" className='col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Project Type" name="projectType" className='col right-col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={prjTypeOptions} />
                    </Form.Item>
                </div>
                <div className='row m-0'>
                    <Form.Item label="Priority" name="priority" className='col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={priorityOptions} />
                    </Form.Item>
                    <Form.Item label="Billable Type" name="billableType" className='col right-col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={billableTypeOptions} />
                    </Form.Item>
                </div>
                <div className='row m-0'>
                    <Form.Item label="Sponsor Name" name="sponsorName" className='col'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label="Project Manager" name="manager" className='col-md-6' rules={[{ required: true, message: "This field is required" }]}>
                        <Select  options={prjManagerList} />
                    </Form.Item>

                </div>
                <div className='row m-0'>
                    <Form.Item label="Start Date" name="estStartDate" className='col '
                        rules={[{ required: true, message: "This field is required" }]}>
                        <DatePicker format={props.data.dateformat == "dd-MM-yyyy" ? "DD-MM-YYYY" : "MM-DD-YYYY"} className='w-100' 
                         disabledDate={(current) =>disabledDate(current)} onChange={handleDateChange}/>
                       
                    </Form.Item>
                    <Form.Item label="End Date" name="estEndDate" className='col right-col'
                     >
                        <DatePicker format={props.data.dateformat == "dd-MM-yyyy" ? "DD-MM-YYYY" : "MM-DD-YYYY"} className='w-100' disabled={!specificValue}
                        disabledDate={(current)=>disableEstEndDate(current)}/>
                    </Form.Item>
                </div>
                <div className='row m-0'>
                <Form.Item  label="Progress indicator by" name="projIndBy" className='col right-col'
                    rules={[{ required: true, message: "This field is required" }]}
                    >
                    <Radio.Group>
                        {completionOptions.map(option => (
                        <Radio
                            key={option.value}
                            value={option.value}
                            className="circle-radio"
                        >
                            {option.label}
                        </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>

                </div>
                <div className='row m-0'>
                    <Form.Item label="Description" name="description" className='col right-col'>
                        <TextArea rows={3} />
                    </Form.Item>
                </div>
                <div className='row m-0 text-end'>
                    <Button type="primary ms-auto cancel-btn" danger onClick={hanldeCloseDrawer}>Cancel</Button>
                    <Button type="primary save-btn ms-1" htmlType='submit'>Save</Button>
                </div>
            </Form>
        </Drawer>
    )
}